const ArrowUpIcon = function ArrowUpIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.54545 0L9.09091 6.23158L0 6.23158L4.54545 0Z" fill="#1EC252" />
    </svg>
  );
};

export default ArrowUpIcon;
